import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import { useAuthStore } from '../../store/auth';
import useUISettings from '../../hooks/useUISettings';

function Navbar() {
  const { isAuthenticated, user } = useAuthStore();
  const { mainMenu } = useUISettings();

  const filteredItems = mainMenu.filter((item) => {
    if (item.admin && user?.role !== 'admin') return false;
    if (item.auth && !isAuthenticated) return false;
    if (item.public === false && !isAuthenticated) return false;
    return true;
  });

  return (
    <nav className="hidden md:flex items-center space-x-6">
      {filteredItems.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          className={({ isActive }) =>
            clsx(
              'text-sm font-medium transition-colors',
              isActive
                ? 'text-purple-400'
                : 'text-gray-400 hover:text-white'
            )
          }
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}

export default Navbar;
